export default {
  mainContent: 1,
  stickHeaderContent: 2,
  leftSidebarContent: 3,
  pageHeaderDropdown: 4,
  stickyNavMax: 4,
  leftSidebarMax: 5,
  topNavDropdown: 5,
  tooltip: 6,
  modalOverlay: 10,
  // TODO: snackbar and zindex should not be at the same level
  snackbar: 10,
  sidebarMenu: 10,
  dndOverlay: 14,
}
